export default "__VITE_ASSET__3110dd13__"